/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_A5Inputs */

const en_viewer_faq_a5 = /** @type {(inputs: Viewer_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Code view provides a full-featured editor with syntax highlighting, auto-completion, and bracket matching. Changes are reflected in the tree view in real time.`)
};

const ko_viewer_faq_a5 = /** @type {(inputs: Viewer_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 코드 뷰에서 구문 강조, 자동 완성, 괄호 매칭 기능을 갖춘 완전한 에디터를 제공합니다. 변경 사항은 트리 뷰에 실시간으로 반영됩니다.`)
};

const ja_viewer_faq_a5 = /** @type {(inputs: Viewer_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。コードビューではシンタックスハイライト、自動補完、ブラケットマッチング機能を備えたフル機能のエディターが使えます。変更はリアルタイムでツリービューに反映されます。`)
};

/**
* | output |
* | --- |
* | "Yes. The Code view provides a full-featured editor with syntax highlighting, auto-completion, and bracket matching. Changes are reflected in the tree view in..." |
*
* @param {Viewer_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_a5 = /** @type {((inputs?: Viewer_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_a5(inputs)
	if (locale === "ko") return ko_viewer_faq_a5(inputs)
	return ja_viewer_faq_a5(inputs)
});